"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const transformToQueryString_1 = tslib_1.__importDefault(require("../../../utils/transformToQueryString"));
const services_1 = tslib_1.__importDefault(require("../../../services"));
async function getAvailabilities(params) {
    const paramsUrl = new URLSearchParams();
    const quantity = String(params.quantity || 1);
    paramsUrl.append('start_at', params.start_at);
    paramsUrl.append('end_at', params.end_at);
    paramsUrl.append('quantity', quantity);
    const items = (0, transformToQueryString_1.default)((params.items || []).map((item) => ({
        id: item.id,
        quantity: item.quantity || 1,
    })));
    const url = `/api/market/items/availability?${paramsUrl.toString()}&${items}`;
    const response = await services_1.default.get(url);
    return response;
}
exports.default = getAvailabilities;
//# sourceMappingURL=service.js.map